import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TabsComponent } from './components/tabs.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    TabsComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    TabsComponent
  ]
})
export class TabModule {}
